module.exports = __webpack_public_path__ + "img/Serro_Ref2.c49db986.png";